import store from "@/store"

class Action {
  constructor() {
    this.timeout = null
    this.attempt = 0
    this.instants = ["DEVICE.StandBy", "DEVICE.PowerOn", "DEVICE.Reboot", "DEVICE.CheckIn", "DEVICE.CheckOut", "DEVICE.Alarm", "DEVICE.Reload"]
    this.regularActions = []
    this.regularBussy = false
    this.regularActive = false
    this.instantActions = []
    this.instantBussy = false
  }
  init() {
    this.initAjax(true)
    this.registerMessages()

    _$.vue.$on("actions", data => {
      if (data === "play") {
        const oldState = this.regularActive
        this.regularActive = true
        if (!oldState) this.processRegulars()
      } else this.regularActive = false
    })
    _$.vue.$on("action", data => {
      const action = { id: data.id || new Date().getTime(), remote: !_$.true(data.id), payload: null }
      delete data.id
      action.payload = data
      this.syncActions(this.filterUniqueActions([action])).catch(err => _$.error(err))
    })
  }

  initAjax(loop = false, immediate = false) {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(
      () => {
        const payload = {
          mac: __.device.get("mac"),
          guest: __.guest.get("id")
        }

        __.api.get
          .actions(payload)
          .then(actions => {
            if (!Array.isArray(actions) || !actions.length) return false
            return this.syncActions(this.filterUniqueActions(actions)).catch(err => _$.error(err))
          })
          .finally(() => {
            this.attempt = window.actionTimeout || 1800000
            if (loop) this.initAjax(true)
          })
      },
      immediate ? 0 : this.attempt
    )
  }
  filterUniqueActions(actions) {
    let mustBeUnique = ["DEVICE.StandBy", "DEVICE.PowerOn", "DEVICE.Reboot", "DEVICE.CheckIn", "DEVICE.CheckOut", "DEVICE.Alarm", "DEVICE.Reload"],
      uniqueBox = []

    return actions.filter(action => {
      if (!action.payload) return false
      if (uniqueBox.indexOf(action.payload.action) >= 0) {
        this.updateAction(action.id, false, "multiple")
        return false
      }
      if (mustBeUnique.indexOf(action.payload.action) >= 0) uniqueBox.push(action.payload.action)

      return true
    })
  }
  async syncActions(actions) {
    if (!Array.isArray(actions)) return false

    for (const action of actions) {
      if (this.instantActions.find(_action => _action.id === action.id)) return false
      if (this.regularActions.find(_action => _action.id === action.id)) return false

      if (this.instants.indexOf(action.payload.action) >= 0) this.instantActions.push(action)
      else this.regularActions.push(action)
    }

    if (this.instantActions.length) this.processInstants()
    if (this.regularActions.length) this.processRegulars()
    return true
  }
  async processInstants(inside = false) {
    if (!this.instantActions.length) {
      this.instantBussy = false
      return false
    }
    if (!inside && this.instantBussy) return false
    else this.instantBussy = true

    const action = this.instantActions.shift()

    return this.processAction(action)
      .then(() => !action.remote && this.updateAction(action.id, true))
      .catch(err => this.updateAction(action.id, false, err))
      .finally(() => this.processInstants(true))
  }
  async processRegulars(inside = false) {
    if (!this.regularActions.length || !this.regularActive) {
      this.regularBussy = false
      return false
    }
    if (!inside && this.regularBussy) return false
    else this.regularBussy = true

    const action = this.regularActions.shift()

    return this.processAction(action)
      .then(() => !action.remote && this.updateAction(action.id, true))
      .catch(err => this.updateAction(action.id, false, err))
      .finally(() => this.processRegulars(true))
  }
  async processAction(action) {
    switch (action.payload.action) {
      case "DEVICE.Reboot":
        _$.sleep(1000).then(() => __.device.reboot())
        return true

      case "DEVICE.StandBy":
        return __.device.standBy()

      case "DEVICE.PowerOn":
        return __.device.powerOn()

      case "DEVICE.CheckIn":
      case "DEVICE.CheckOut":
        return __.platform.toPlatform().then(() => __.platform.syncData("guest"))

      case "DEVICE.SyncData":
        return __.platform.syncData()

      case "DEVICE.Reload":
        setTimeout(() => __.platform.toPlatform().then(() => window.location.reload(true)), 2000)
        return true

      case "DEVICE.Alarm":
        this.makeAlarm(action.payload.params)
        return true

      case "IPTV.ChannelGo":
        var channel = store.getters["live/allChannels"].find(channel => channel.id == action.payload.params?.channelNumber)
        if (channel) {
          if (!__.guest.welcome()) sessionStorage.setItem("welcome", store.getters.language.code)
          store.commit("live/category", null)
          store.commit("live/channel", channel)
          if (this_.$route.name !== "live") __.platform.go("/live/all/osd")
        }
        return true

      case "IPTV.Records":
        store.dispatch("live/fetchRecords")
        return true

      case "Message":
        action.payload.params.id = action.id
        action.payload.params.readed = false
        action.payload.params.date = new Date(action.created_at).getTime()
        this.newMessage(action.payload.params)
        return true

      case "Message.Image":
        _$.vue.$popup.image(action.payload.params.path?.host())
        return true

      case "Message.Video":
        _$.vue.$popup.video(action.payload.params.path?.host(), true, 0, action.payload.params.autoClose ? false : true)
        return true

      case "Message.Marquee":
        _$.vue.$marquee(action.payload.params.data, action.payload.params.repeat, action.payload.params.speed)
        return true

      case "DEVICE.Mute":
        __.device.mute(action.payload.params?.state)
        return true

      case "DEVICE.Volume":
        __.device.volume(parseInt(action.payload.params?.state))
        return true

      default:
        throw "Not found"
    }
  }
  async updateAction(id, status, msg) {
    if (typeof msg === "object") msg = msg.message
    return __.api.set.action({ id: id, status: status ? true : false, message: msg })
  }

  registerMessages() {
    const localeMessages = _$.store.getItem("services.messages")
    if (Array.isArray(localeMessages) && localeMessages.length) store.state.services.messages = localeMessages
  }
  newMessage(message) {
    if (store.state.services.messages.find(_message => _message.id === message.id)) return false

    store.state.services.messages.push(message)
    this.saveMessages()

    if (message.autoOpen) _$.vue.$messages(message.id)
  }
  saveMessages() {
    _$.store.setItem("services.messages", store.state.services.messages)
  }
  allMessagesReaded() {
    store.state.services.messages = store.state.services.messages.map(message => {
      return (message.readed = true)
    })
    this.saveMessages()
  }
  makeAlarm(params) {
    const alarmObject = {
      type: params.type,
      time: "alarm",
      path: params.path,
      skip: params.skip
    }

    if (!__.device.isPowerOn()) {
      __.platform._openingMedia = alarmObject
      __.device.powerOn()
    } else {
      if (["video", "image"].indexOf(alarmObject.type) < 0) return
      _$.vue.$popup[alarmObject.type](alarmObject.path?.host(), alarmObject.skip !== false)
    }
  }
}

export default new Action()
